import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-preview-multiple-choice-true-or-false',
  templateUrl: './preview-multiple-choice-true-or-false.component.html',
  styleUrls: ['./preview-multiple-choice-true-or-false.component.scss']
})
export class PreviewMultipleChoiceTrueOrFalseComponent {


  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }
}

